import Vue from 'vue';
import App from './App.vue';
import store from './store/store';
import './assets/app.scss';
import VTooltip from 'v-tooltip'
import { ValidationProvider,ValidationObserver, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import './assets/app.scss';
import vueCountryRegionSelect from 'vue-country-region-select'

Vue.use(vueCountryRegionSelect)
extend('required', {
  ...required,
  message: 'Please enter a {_field_}'
});
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

Vue.use(VTooltip, {
  defaultTrigger: window.innerWidth > 768 ? 'hover focus click' : 'click'
})

Vue.filter('moneySaleFormat', (price) => {
  if (price) {
    return `$${price}`;
  }
  return '';
});

Vue.filter('getProductDesc', product => {
  return product.body_html.replace(/<script>[\s\S]*<\/script>/g,'').replace( /(<([^>]+)>)/ig, '');
});

Vue.filter('intToDecimalPrice', int => '$' + (int / 100).toFixed(2));

Vue.filter('getProductVariantImage', function (product,variantId){
  var productVariantImage = product.images.find(x => x.variant_ids.includes(variantId));
  if(productVariantImage){
    return productVariantImage.src;
  }
  return (product.images.length > 0) ? product.images[0].src : '';
});

Vue.filter('getProductImage', product => (product.images.length > 0) ? product.images[0].src : '');


/* eslint-disable no-unused-vars */
const RedeemGiftApp = new Vue({
  el: '#RedeemGift',
  data: {
  },
  store,
  created() {
  },
  render: h => h(App),
});
